import skynetAPI from 'api/index';
import { injectPendingChangesOperationHeader } from 'app/services/pendingChangesOperation';

import { logger } from 'utils/logger';

import accountsApi from './accounts';
import aiApi from './ai';
import applyAPI from './apply';
import ausAPI from './aus';
import ApiClient from './client';
import crmAPI from './crm';
import documentsAPI from './documents';
import feesAPI from './fees';
import formsAPI from './forms';
import integrationsAPI from './integrations';
import loanProcessingAPI from './loanProcessing';
import loansAPI from './loans';
import notificationsAPI from './notifications';
import { applyPendingChangesAuthorsHeader } from './pendingChangesAuthorsHeader';
import pricingAPI from './pricing';
import telephonyAPI from './telephony';
import underwritingAPI from './underwriting';

export const httpAccountsApi = new ApiClient(accountsApi, logger);
export const httpApplyApi = new ApiClient(applyAPI, logger);
export const httpPricingApi = new ApiClient(pricingAPI, logger);
export const httpUnderwritingApi = new ApiClient(underwritingAPI, logger);
export const httpSkynetApi = new ApiClient(skynetAPI, logger);
export const httpNotificationsApi = new ApiClient(notificationsAPI, logger);
export const httpTelephonyApi = new ApiClient(telephonyAPI, logger);
export const httpFormsApi = new ApiClient(formsAPI, logger);
export const httpFeesApi = new ApiClient(feesAPI, logger);
export const httpDocumentsApi = new ApiClient(documentsAPI, logger);
export const httpLoansApi = new ApiClient(loansAPI, logger);
export const httpLoanProcessingApi = new ApiClient(loanProcessingAPI, logger);
export const httpAusApi = new ApiClient(ausAPI, logger);
export const httpAiApi = new ApiClient(aiApi, logger);
export const httpCrmApi = new ApiClient(crmAPI, logger);
export const httpIntegrationsApi = new ApiClient(integrationsAPI, logger);

[httpSkynetApi, httpLoansApi, httpPricingApi].forEach(httpApi =>
  httpApi.injectRequestInterceptor(applyPendingChangesAuthorsHeader),
);

[httpSkynetApi, httpLoansApi].forEach(injectPendingChangesOperationHeader);
